const config = {
  app: {
    version: 'v16.17.0',
    url: 'https://app.leavedates.com',
    recaptchaSiteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,
  },
}

export default config
